const button = document.querySelector('.to-top');
const toTop = () => {
  window.scroll({
    top: 0,
    behavior: 'smooth',
  });
};

const handleScroll = (event) => {
  if (event.target.scrollingElement.scrollTop > 100) {
    button?.classList.add('active');
  } else {
    button?.classList.remove('active');
  }
};

button?.addEventListener('click', toTop, false);
button && document.addEventListener('scroll', handleScroll, false);
